import React from 'react'
import { Button } from 'rsuite'

type props = {
  url: string
  fileName: string
}

export const DownloadButton = ({ url, fileName }: props) => {
  const handleDownload = () => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([ blob ]))
        const link = document.createElement('a')
        link.href = url
        const extension = url.split('.').pop() || 'pdf'
        link.download = `${fileName}.${extension}`
        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error('Error fetching the file:', error)
      })
  }

  return (
    <div>
      <Button appearance="primary" onClick={handleDownload}>
        Скачать
      </Button>
    </div>
  )
}